import type { Locale } from '@mfw/translations';

import type {
  UiUpdateOrganizationMemberProfile,
  ApiOrganizationMemberProfile,
  UiOrganizationMemberProfile,
} from '../../schemas/organizationMemberProfile.schema';

import { mapTranslationsFromApi } from './translations.mappers';
import { getLabelFromTranslations } from '../../utils';

export function mapOrganizationMemberProfileFromApi(
  profile: ApiOrganizationMemberProfile | null | undefined,
  locale: Locale,
): UiOrganizationMemberProfile | null {
  if (!profile) return null;
  return {
    id: profile.id,
    description: profile.description ?? null,
    expertiseTags: (profile.expertiseTags ?? []).map((tag) => ({
      label: getLabelFromTranslations(
        locale,
        mapTranslationsFromApi(tag.translations),
      ),
      value: tag.id,
    })),
    locations: profile.locations ?? [],
    organizationId: profile.organizationId,
    socialMedia: (profile.socialMedia ?? []).map((media) => ({
      type: media.type as UiOrganizationMemberProfile['socialMedia'][number]['type'],
      url: media.url,
    })),
    userId: profile.userId,
    workplaces: profile.workplaces ?? [],
  };
}

export function mapUpdateOrganizationMemberProfileToApi(
  values: UiUpdateOrganizationMemberProfile,
) {
  return {
    description: values.description,
    expertiseTagIds: values.expertiseTagIds,
    locations: values.locations,
    socialMedia: values.socialMedia,
    workplaces: values.workplaces,
  };
}
